export default __webpack_public_path__ + "static/dark-country-9800c9fab466bb706c44ef2fa0f49948.png";